import { c as _c } from "react/compiler-runtime";
import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';
type AdvisorsToolbarExtrasContextValue = {
  rightElements: ReactNode;
  setRightElements: (elements: ReactNode) => void;
  /** Content rendered under the toolbar, outside the scrollable main section (e.g. Wil usage banner). */
  belowToolbar: ReactNode;
  setBelowToolbar: (elements: ReactNode) => void;
};
const AdvisorsToolbarExtrasContext = createContext<AdvisorsToolbarExtrasContextValue | null>(null);
export const AdvisorsToolbarExtrasProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [rightElements, setRightElements] = useState(null);
  const [belowToolbar, setBelowToolbar] = useState(null);
  let t1;
  if ($[0] !== belowToolbar || $[1] !== rightElements) {
    t1 = {
      rightElements,
      setRightElements,
      belowToolbar,
      setBelowToolbar
    };
    $[0] = belowToolbar;
    $[1] = rightElements;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const value = t1;
  let t2;
  if ($[3] !== children || $[4] !== value) {
    t2 = <AdvisorsToolbarExtrasContext.Provider value={value}>{children}</AdvisorsToolbarExtrasContext.Provider>;
    $[3] = children;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const useAdvisorsToolbarRightElements = () => {
  return useContext(AdvisorsToolbarExtrasContext)?.rightElements ?? null;
};

/** Sets Advisors toolbar right-side elements for this section’s mount lifetime. */
export const useSetAdvisorsToolbarRightElements = elements => {
  const $ = _c(4);
  const setRightElements = useContext(AdvisorsToolbarExtrasContext)?.setRightElements;
  let t0;
  let t1;
  if ($[0] !== elements || $[1] !== setRightElements) {
    t0 = () => {
      if (!setRightElements) {
        return;
      }
      setRightElements(elements);
      return () => {
        setRightElements(null);
      };
    };
    t1 = [setRightElements, elements];
    $[0] = elements;
    $[1] = setRightElements;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};
export const useAdvisorsBelowToolbar = () => {
  return useContext(AdvisorsToolbarExtrasContext)?.belowToolbar ?? null;
};

/**
 * Sets content rendered under the Advisors toolbar (sibling, outside the main chat scroll
 * region) for this section’s mount lifetime.
 */
export const useSetAdvisorsBelowToolbar = elements => {
  const $ = _c(4);
  const setBelowToolbar = useContext(AdvisorsToolbarExtrasContext)?.setBelowToolbar;
  let t0;
  let t1;
  if ($[0] !== elements || $[1] !== setBelowToolbar) {
    t0 = () => {
      if (!setBelowToolbar) {
        return;
      }
      setBelowToolbar(elements);
      return () => {
        setBelowToolbar(null);
      };
    };
    t1 = [setBelowToolbar, elements];
    $[0] = elements;
    $[1] = setBelowToolbar;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};